import axios from 'axios';

import { environment } from '../config';
import { clearSession, getToken } from './session';

const api = axios.create({
  baseURL: environment.apiUrl,
  timeout: 120000, // 2 min for AI processing (PDF parsing, vision, etc.)
  // Don't set Content-Type here — axios sets it automatically:
  // - application/json for objects
  // - multipart/form-data (with boundary) for FormData
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const authorization = error.config?.headers?.Authorization;
      const rejectedToken = typeof authorization === 'string' && authorization.startsWith('Bearer ')
        ? authorization.slice(7) : undefined;
      // A delayed request from a previous login must not invalidate a new session.
      if (rejectedToken) clearSession(rejectedToken);
    }
    return Promise.reject(error);
  }
);

export default api;
